import { useEffect } from "react";
import { useHistory } from "react-router";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { LF } from "./Constantes/general";

const LFPago = ({ qParams: { idPoliza } }) => {
  const history = useHistory();

  useEffect(() => {
    history.replace(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
    history.push(
      `/pago?idPoliza=${idPoliza}&codProducto=${PRODUCTOS.LINEAS_FINANCIERAS}`
    );
  }, [history, idPoliza]);

  return null;
};

export default LFPago;
